module.exports = " <div class=work :style=workStyle _v-2f7699fc=\"\"> <work-frame :image=image :ratio=ratio :width=width :link=link _v-2f7699fc=\"\"></work-frame> <div class=work-info-container :style=workInfoContainerStyle _v-2f7699fc=\"\"> <work-info :title=title :subtitle=subtitle _v-2f7699fc=\"\"></work-info> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-2f7699fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Work.vue
 ** module id = 30
 ** module chunks = 1
 **/